import React from "react"
import { graphql } from "gatsby"
import Flink from '~/components/shared/flink'
import { Seo } from '~/components/shared/seo'
import "~/styles/pages/wholesale.scss"
import { notBlank, imgSize, stripHTML } from '~/utils/helpers'


const Wholesale = ({ data: { wholesale } }) => {
  const page = wholesale.data

  return (
    <div className="wholesale">
      <div className="hero hero__wrap" style={{backgroundImage: `url('${imgSize(page.hero_image,1200)}')`}}>
        {notBlank(page.title) && (
          <h1 className="sevday_hero-title">
            {page.title}
          </h1>
        )}
      </div>

      <div className="wholesale_content wholesale_content-left">
        <div className="wholesale_content-wrap">
          <div className="wholesale_content-copy">
            {notBlank(page.content_left_header) && (
              <h2 className="wholesale_content-header">
                {page.content_left_header}
              </h2>
            )}
            {notBlank(page.content_left_copy) && (
              <div dangerouslySetInnerHTML={{ __html: page.content_left_copy }} />
            )}
            {notBlank(page.content_left_cta) && (
              <div className="page-landing-cta">
                <Flink className="callout_landing-cta_button" href={"https://buck-mason-usa.wholesale.shopifyapps.com/accounts/sign_up"}>
                  {page.content_left_cta}
                </Flink>
              </div>
            )}
          </div>
        </div>
        {notBlank(page.content_left_img) && (
          <img className="wholesale_content-img" src={imgSize(page.content_left_img,900)} alt="Buck Mason" />
        )}

      </div>

      <div className="wholesale_content wholesale_content-right">
        {notBlank(page.content_right_img) && (
          <img className="wholesale_content-img" src={imgSize(page.content_right_img,900)} alt="Buck Mason" />
        )}
        <div className="wholesale_content-wrap">
          <div className="wholesale_content-copy">
            {notBlank(page.content_right_header) && (
              <h2 className="wholesale_content-header">
                {page.content_right_header}
              </h2>
            )}
            {notBlank(page.content_right_copy) && (
              <div dangerouslySetInnerHTML={{ __html: page.content_right_copy }} />
            )}
            {notBlank(page.content_right_cta) && (
              <div className="page-landing-cta">
                <Flink className="callout_landing-cta_button" href={page.content_right_cta_link}>
                  {page.content_right_cta}
                </Flink>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="wholesale_centered">
        {notBlank(page.centered_img) && (
          <img className="wholesale_centered-img" src={imgSize(page.centered_img,900)} alt="Buck Mason" />
        )}
      </div>

      <div className="page-perfecttee-press">
        <div className="page-perfecttee-press--item">
          <div className="page-perfecttee-press--quote" dangerouslySetInnerHTML={{ __html: page.s2_quote1 }} />
          <img src={imgSize(page.s2_quote1_image,400)} className="page-perfecttee-press--logo" alt={stripHTML(page.s2_quote1)} />
        </div>
        <div className="page-perfecttee-press--item">
          <div className="page-perfecttee-press--quote" dangerouslySetInnerHTML={{ __html: page.s2_quote2 }} />
          <img src={imgSize(page.s2_quote2_image,400)} className="page-perfecttee-press--logo" alt={stripHTML(page.s2_quote2)} />
        </div>
        <div className="page-perfecttee-press--item">
          <div className="page-perfecttee-press--quote" dangerouslySetInnerHTML={{ __html: page.s2_quote3 }} />
          <img src={imgSize(page.s2_quote3_image,400)} className="page-perfecttee-press--logo" alt={stripHTML(page.s2_quote3)} />
        </div>
      </div>
    </div>
  )
}
export default Wholesale


export const Head = () => (
  <Seo 
    title={'Wholesale Inquiry'}
    url={`/pages/wholesale`}
  />
)


export const pageQuery = graphql`
  {
    wholesale: contentPage(type: {eq: "Wholesale"}) {
      data
    }
  }
`;



